import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './AddEntityWatcherButtonContainer';
import { getWatcherEntityLabel } from '../../WatchersUtils';
import { NewWatcherEntityQueryParams } from '../../watchers.types';
import { PrimaryButton, SecondaryButton } from '../../../components/button';
import { withUser } from '../../../user/UserContext';
import { UserContextType } from '../../../user/user.types';
import { CancelWatcherCreationButton } from '../cancel-watcher-creation/CancelWatcherCreationButton';

type Props = {
  queryParams: NewWatcherEntityQueryParams;
  uniqueId: string;
  restrict: () => void;
  source: string;
  onButtonClick?: Function;
  secondary?: boolean;
} & UserContextType &
  PropsFromRedux;

export class RawAddEntityWatcherButton extends React.Component<Props> {
  static defaultProps = {
    onButtonClick: () => {},
    secondary: false,
  };

  deleteWatcher = async () => {
    const { onButtonClick, deleteUserWatcher, uniqueId, source } = this.props;
    if (onButtonClick) {
      onButtonClick();
    }
    try {
      await deleteUserWatcher(uniqueId, source);
    } catch (error) {
      throw error;
    }
  };

  addWatcher = async () => {
    const {
      onButtonClick,
      createUserWatcher,
      queryParams,
      uniqueId,
      source,
    } = this.props;
    if (onButtonClick) {
      onButtonClick(true);
    }

    try {
      await createUserWatcher(queryParams, uniqueId, source);
    } catch (error) {
      throw error;
    }
  };

  render() {
    const {
      restrict,
      accessPremium,
      isWatched,
      secondary,
      queryParams,
      uniqueId,
    } = this.props;

    const tooltipId = `add-watcher-entity-${uniqueId}`;

    const creationProps = {
      onClick: !accessPremium && restrict ? restrict : this.addWatcher,
      iconLeft: 'notifications_none',
    };
    const entityLabel = getWatcherEntityLabel(queryParams);

    return (
      <>
        {!isWatched && (
          <>
            {!secondary && (
              <PrimaryButton {...creationProps}>
                <FormattedMessage id="watchers/components/add-entity-watcher/AddEntityWatcherButton.tsx/1" />
                {entityLabel}
              </PrimaryButton>
            )}
            {secondary && (
              <SecondaryButton {...creationProps}>
                <FormattedMessage id="watchers/components/add-entity-watcher/AddEntityWatcherButton.tsx/2" />
                {entityLabel}
              </SecondaryButton>
            )}
          </>
        )}
        {isWatched && (
          <CancelWatcherCreationButton
            deleteWatcher={
              !accessPremium && restrict ? restrict : this.deleteWatcher
            }
            tooltipId={tooltipId}
          />
        )}
      </>
    );
  }
}

export const AddEntityWatcherButton = Connect(
  withUser(RawAddEntityWatcherButton),
);
